<template>
  <div class="max-w-7xl mx-auto py-8 px-4">
    <h1 class="text-3xl font-bold text-[#D84040] mb-8 text-center">All Artists / <span class="text-2xl">সকলো শিল্পী</span></h1>

    <!-- Loading -->
    <div v-if="loading" class="text-center py-10">
      <p class="text-gray-500 text-lg">Loading artists...</p>
    </div>

    <!-- Error -->
    <div v-else-if="error" class="text-center py-10">
      <p class="text-red-500">{{ error }}</p>
    </div>

    <!-- Artists Grid -->
    <div v-else class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      <div 
        v-for="artist in artists" 
        :key="artist.id" 
        class="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
      >
        <div class="h-48 overflow-hidden bg-gray-100">
            <img 
            :src="artist.image" 
            :alt="artist.name" 
            class="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
            @error="handleImageError"
            />
        </div>
        
        <div class="p-4">
          <h2 class="text-xl font-bold text-gray-800 mb-1 truncate">{{ artist.name }}</h2>
          <p class="text-sm text-[#D84040] font-medium mb-3 truncate">{{ artist.profession }}</p>
          
          <router-link 
            :to="`/profile/${artist.id}`" 
            class="block w-full text-center bg-gray-100 hover:bg-[#D84040] hover:text-white text-gray-700 font-semibold py-2 rounded transition-colors duration-300"
          >
            View Profile
          </router-link>
        </div>
      </div>
    </div>
    
    <!-- Empty State -->
    <div v-if="!loading && !error && artists.length === 0" class="text-center py-16 bg-gray-50 rounded-lg">
        <p class="text-gray-500 text-lg">No artists found.</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || "https://sanskritirdapoon.in/api";
const FILE_BASE_URL = process.env.VUE_APP_FILE_BASE_URL || "https://sanskritirdapoon.in";

const artists = ref([]);
const loading = ref(true);
const error = ref('');

const resolveImage = (img) => {
  if (!img) return `${FILE_BASE_URL}/images/default.png`;
  if (img.startsWith('data:')) return img;
  if (img.startsWith('http')) return img;
  return `${FILE_BASE_URL}${img}`;
};

const handleImageError = (e) => {
  e.target.src = `${FILE_BASE_URL}/images/default.png`;
};

const fetchArtists = async () => {
    try {
        const res = await fetch(`${API_BASE_URL}/artists`);
        if (!res.ok) throw new Error('Failed to fetch artists');
        const data = await res.json();
        
        // Filter approved artists and map images
        artists.value = data
            .filter(a => a.is_approved)
            .map(a => ({
                ...a,
                image: resolveImage(a.image)
            }));
            
    } catch (err) {
        console.error('Error fetching artists:', err);
        error.value = 'Failed to load artists. Please try again later.';
    } finally {
        loading.value = false;
    }
};

onMounted(() => {
    fetchArtists();
    window.scrollTo(0, 0);
});
</script>
